// extracted by mini-css-extract-plugin
export var alertIcon = "_sb-0";